module.exports = __webpack_public_path__ + "img/LMDC-logo.7a514024.png";